import type { GameEvent, SetupGameState } from "../types";
import { drawCards } from "../transitions/draw-cards";
import type { TransitionResult } from "../transitions/advance-phase";

export const NORMAL_DRAW_COUNT = 5 as const;

function eventId(actionSequence: number, ordinal: number): string {
  return `event-${actionSequence}-${ordinal}`;
}

/** Resolves the automatic Draw effect after a schema-V2 state enters Draw. */
export function resolveDrawPhase(
  state: Readonly<SetupGameState>,
  actionSequence: number,
  startingEventOrdinal: number,
): TransitionResult {
  const playerId = state.activePlayerId;
  if (state.firstTurnDrawStatus[playerId] === "pending") {
    const event: GameEvent = {
      type: "draw-skipped",
      eventId: eventId(actionSequence, startingEventOrdinal),
      actionSequence,
      playerId,
      reason: "opening-hand-used-for-first-turn",
    };

    return {
      state: {
        ...state,
        firstTurnDrawStatus: {
          ...state.firstTurnDrawStatus,
          [playerId]: "consumed",
        },
      },
      events: [event],
    };
  }

  return drawCards(state, playerId, NORMAL_DRAW_COUNT, actionSequence, startingEventOrdinal);
}
